import { height, width } from '@mui/system';
import React, { useRef, useEffect, useState, forwardRef } from 'react';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faTrash
} from "@fortawesome/free-solid-svg-icons";
import Tooltip from '@mui/material/Tooltip';
import { ConfirmationModal } from './ConfirmationModal';
import { calculateBoxPercentage, calculateBoxFromPercentage, fitToFrame, calculateCenterPosition } from '../common_functions/video_annotator_functions';
const newheight = window.screen.availHeight < 900 ? window.screen.availHeight - 128 : window.screen.availHeight - 190;
const marginLft = window.screen.availHeight < 1000 ? 205 : 317;



const ROISelector = forwardRef(({
  isMuted,
  setSeekerBar,
  vidsrc,
  progressBarTime,
  zoomAreaRatio,
  setZoomAreaRatio,
  zoomArea,
  setZoomArea,
  visibleVideoDimensions,
  setVisibleVideoDimensions,
  showCroppedVideo,
  setShowCroppedVideo,
  enableROI,
  playPause,
  selecteROIindex,
  setSelecteROIindex,
  setroiList,
  roiList,
  openAlertPopup,
  setAlertMessage,
  saveTheAnnotationData,
  selectedEditableROIindex,
  setSelectedEditableROIindex,
  addRoiCoordinates,
  updateRoiCoordinates,
  deleteRoiCoordinates,
  urlParams,
  setEnableROI,
  open,
  setOpen,
  buttonAction,
  setbuttonAction,
  handleOpen,
  playing,
  setPlaying,
  newROILabel
}, refs) => {
  const { progressBarRef, playVideoRef, roiDrawRef } = refs;
  const canvasRef = useRef(null);
  const [isDrawing, setIsDrawing] = useState(false);
  const [startPos, setStartPos] = useState({ x: 0, y: 0 });
  const [dragging, setDragging] = useState(false);
  const [resizing, setResizing] = useState(null); // New state for resizing
  const [videoAlign, setVideoAlign] = useState(marginLft);
  const [vidHeightVal, setVidHeightVal] = useState(0);
  const [isBuffering, setIsBuffering] = useState(false);
  const [stallStart, setStallStart] = useState(0);
  const [roiIsBuffering, setROIIsBuffering] = useState(false);
  const [roiStallStart, setROIStallStart] = useState(0);


  const handleClose = () => {
    setbuttonAction({
      event: '',
      eventMessage: ''
    });
    setOpen(false);
  };

  useEffect(() => {
    const video = enableROI ? roiDrawRef.current : playVideoRef.current;
    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');
    const updateCanvasSize = () => {
      let vidheight = enableROI ? newheight : video.offsetHeight;
      let widthVal = (video.videoWidth / video.videoHeight) * vidheight;
      canvas.width = (video.videoWidth / video.videoHeight) * vidheight;
      canvas.height = vidheight;
      let vdimension = {
        width: (video.videoWidth / video.videoHeight) * vidheight,
        height: vidheight,
        videoWidth: video.videoWidth,
        videoheight: video.videoHeight
      }
      setVidHeightVal(vidheight);
      setVisibleVideoDimensions(vdimension)
      setVideoAlign(((video.clientWidth - widthVal) / 2).toFixed(2) - 1);
    };
    setZoomArea(null);
    video.addEventListener('loadedmetadata', () => {
      // Update canvas size after video metadata is loaded
      updateCanvasSize();
    });

    return () => {
      video?.removeEventListener('loadedmetadata', updateCanvasSize);
    };
  }, [])




  useEffect(() => {
    const video = enableROI ? roiDrawRef.current : playVideoRef.current;
    const canvas = canvasRef.current;
    const ctx = canvas?.getContext('2d');

    const updateCanvasSize = () => {
      let vidheight = enableROI ? newheight : video.offsetHeight;
      let widthVal = (video.videoWidth / video.videoHeight) * vidheight;
      canvas.width = (video.videoWidth / video.videoHeight) * vidheight;
      canvas.height = vidheight;
      let vdimension = {
        width: (video.videoWidth / video.videoHeight) * vidheight,
        height: vidheight,
        videoWidth: video.videoWidth,
        videoheight: video.videoHeight
      }
      setVidHeightVal(vidheight);
      setVisibleVideoDimensions(vdimension)
      setVideoAlign(((video.clientWidth - widthVal) / 2).toFixed(2) - 1);
    };

    const drawVideo = () => {
      ctx.clearRect(0, 0, canvas.width, canvas.height);

      if (zoomArea) {
        // Draw the rectangle
        ctx.fillStyle = 'rgba(255, 0, 0, 0.3)';
        ctx.fillRect(zoomArea.x, zoomArea.y, zoomArea.width, zoomArea.height);
        ctx.strokeStyle = 'red';
        ctx.lineWidth = 2;
        ctx.strokeRect(zoomArea.x, zoomArea.y, zoomArea.width, zoomArea.height);
        // Draw resize handles (small squares at corners)
        drawResizeHandles(ctx, zoomArea);
      }
    };

    updateCanvasSize();
    drawVideo();
  }, [zoomArea, videoAlign, showCroppedVideo, enableROI]);

  const drawResizeHandles = (ctx, area) => {
    const handleSize = 8;
    ctx.fillStyle = 'blue';
    // Top-left corner
    ctx.fillRect(area.x - handleSize / 2, area.y - handleSize / 2, handleSize, handleSize);
    // Top-right corner
    ctx.fillRect(area.x + area.width - handleSize / 2, area.y - handleSize / 2, handleSize, handleSize);
    // Bottom-left corner
    ctx.fillRect(area.x - handleSize / 2, area.y + area.height - handleSize / 2, handleSize, handleSize);
    // Bottom-right corner
    ctx.fillRect(area.x + area.width - handleSize / 2, area.y + area.height - handleSize / 2, handleSize, handleSize);
  };

  const getResizingHandle = (x, y) => {
    const handleSize = 8;
    if (!zoomArea) return null;

    const corners = [
      { x: zoomArea.x, y: zoomArea.y, corner: 'top-left' },
      { x: zoomArea.x + zoomArea.width, y: zoomArea.y, corner: 'top-right' },
      { x: zoomArea.x, y: zoomArea.y + zoomArea.height, corner: 'bottom-left' },
      { x: zoomArea.x + zoomArea.width, y: zoomArea.y + zoomArea.height, corner: 'bottom-right' },
    ];

    for (let corner of corners) {
      if (
        Math.abs(x - corner.x) < handleSize &&
        Math.abs(y - corner.y) < handleSize
      ) {
        return corner.corner;
      }
    }

    return null;
  };

  const handleMouseDown = (e) => {
    const rect = canvasRef.current.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;

    const resizingHandle = getResizingHandle(x, y);

    if (resizingHandle) {
      setResizing(resizingHandle);
    } else if (zoomArea && isInsideZoomArea(x, y)) {
      // If clicked inside the drawn rectangle, initiate dragging
      setDragging(true);
    } else {
      // Otherwise, start drawing a new rectangle
      setStartPos({ x, y });
      setIsDrawing(true);
      setZoomArea({ x, y, width: 0, height: 0 }); // Initialize with width and height of 0
    }
  };

  const handleMouseMove = (e) => {
    const rect = canvasRef.current.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;

    if (isDrawing && canvasRef?.current && canvasRef?.current?.width) {
      const width = x - startPos.x;
      const height = y - startPos.y;
      setZoomArea({
        x: Math.max(0, Math.min(startPos.x, canvasRef.current.width - Math.abs(width))),
        y: Math.max(0, Math.min(startPos.y, canvasRef.current.height - Math.abs(height))),
        width: Math.min(Math.abs(width), canvasRef.current.width - startPos.x),
        height: Math.min(Math.abs(height), canvasRef.current.height - startPos.y),
      });
    } else if (dragging && canvasRef?.current && zoomArea && canvasRef?.current?.width) {
      // Move the rectangle while keeping it within canvas boundaries
      const newZoomArea = {
        ...zoomArea,
        x: Math.max(0, Math.min(x - zoomArea.width / 2, canvasRef.current.width - zoomArea.width)),
        y: Math.max(0, Math.min(y - zoomArea.height / 2, canvasRef.current.height - zoomArea.height)),
      };
      setZoomArea(newZoomArea);
    } else if (resizing) {
      // Handle resizing from the selected corner
      handleResize(x, y);
    }
  };

  const handleMouseUp = () => {
    setIsDrawing(false);
    setDragging(false);
    setResizing(null);
  };

  const handleResize = (x, y) => {
    const newZoomArea = { ...zoomArea };
    switch (resizing) {
      case 'top-left':
        newZoomArea.width += newZoomArea.x - x;
        newZoomArea.height += newZoomArea.y - y;
        newZoomArea.x = x;
        newZoomArea.y = y;
        break;
      case 'top-right':
        newZoomArea.width = x - newZoomArea.x;
        newZoomArea.height += newZoomArea.y - y;
        newZoomArea.y = y;
        break;
      case 'bottom-left':
        newZoomArea.width += newZoomArea.x - x;
        newZoomArea.height = y - newZoomArea.y;
        newZoomArea.x = x;
        break;
      case 'bottom-right':
        newZoomArea.width = x - newZoomArea.x;
        newZoomArea.height = y - newZoomArea.y;
        break;
      default:
        break;
    }
    setZoomArea(newZoomArea);
  };

  const isInsideZoomArea = (x, y) => {
    return (
      zoomArea &&
      x >= zoomArea.x &&
      x <= zoomArea.x + zoomArea.width &&
      y >= zoomArea.y &&
      y <= zoomArea.y + zoomArea.height
    );
  };

  const handleSubmit = () => {
    let videoDimensionRatio = calculateBoxPercentage(visibleVideoDimensions.width, visibleVideoDimensions.height, zoomArea.x, zoomArea.y, zoomArea.width, zoomArea.height);
    setZoomAreaRatio(videoDimensionRatio);
    setShowCroppedVideo(true);
  };

  const handleSubmitROI = () => {
    if (selectedEditableROIindex != -1) {
      setSelectedEditableROIindex(-1);
      setSelecteROIindex(0);
      updateRoiCoordinates(roiList[selectedEditableROIindex].roi_id, zoomAreaRatio, roiList[selectedEditableROIindex].label);
      setAlertMessage({
        Errortype: "Success",
        title: "Success",
        message: "ROI updated successfully!!!",
      });
      setEnableROI(false);
    } else {
      addRoiCoordinates([zoomAreaRatio], newROILabel);
      setAlertMessage({
        Errortype: "Success",
        title: "Success",
        message: "New ROI saved successfully!!!",
      });
      setEnableROI(false);
    }
    openAlertPopup();
    handleDeleteRectangle()
  }

  const handleEventSubmitConfirmation = () => {
    if (buttonAction.event == 'Add ROI') {
      handleSubmitROI();
    } else if (buttonAction.event == 'Delete') {
      handleDeleteRectangle()
    }
    else if (buttonAction.event == 'Update') {
      handleSubmitROI();
    }
    handleClose();
  }

  const handleDeleteRectangle = () => {
    if (selectedEditableROIindex != -1 && buttonAction.event == 'Delete') {
      deleteRoiCoordinates(roiList[selectedEditableROIindex].roi_id);
      setSelectedEditableROIindex(-1);
      setSelecteROIindex(0);
      setEnableROI(false);
    }
    setIsDrawing(false);
    setStartPos({ x: 0, y: 0 });
    setZoomArea(null);
    setDragging(false);
    setResizing(null);
    setShowCroppedVideo(false)
  };



  return (
    <div>
      <div className='containeForROISelectorModal' style={{ background: enableROI ? 'white' : 'none', zIndex: enableROI ? 201 : '0', visibility: enableROI ? 'visible' : 'hidden' }}>
        {/* Roi controller player */}
        <video
          className='videoplayer'
          autoload='metadata'
          muted={isMuted}
          ref={roiDrawRef}
          height={newheight}
          preload='auto'
          style={{
            display: 'block', marginBottom: '10px',
            marginLeft: `${enableROI ? marginLft : videoAlign}px`,
            visibility: enableROI ? !showCroppedVideo ? 'visible' : 'hidden' : 'hidden'
          }}
        >
          <source src={vidsrc} type='video/mp4' />
          Your browser does not support the video tag.
        </video>
        <div style={{ visibility: !enableROI ? 'hidden' : showCroppedVideo ? 'hidden' : 'visible', marginLeft: `${enableROI ? marginLft : videoAlign}px` }}>
          <canvas
            ref={canvasRef}
            style={{
              border: '1px solid black',
              cursor:
                resizing || dragging
                  ? 'grabbing'
                  : isDrawing
                    ? 'crosshair'
                    : 'default',
              display: 'block',
              position: 'absolute',
              zIndex: '220'
            }}
            onMouseDown={handleMouseDown}
            onMouseMove={handleMouseMove}
            onMouseUp={handleMouseUp}
          ></canvas>
        </div>
        <div className='croppedVideoContainer' style={{ visibility: (showCroppedVideo || selecteROIindex != 0) ? 'visible' : 'hidden', marginTop: '0px', marginLeft: `${enableROI ? marginLft : '0'}px` }}>
          {
            selecteROIindex == 0 && <CroppedVideo zoomAreaRatio={zoomAreaRatio} playVideoRef={roiDrawRef} visibleVideoDimensions={visibleVideoDimensions} videoAlign={videoAlign} progressBarTime={progressBarTime} enableROI={enableROI} vidheight={vidHeightVal} canvasRef={canvasRef} />
          }
        </div>
      </div>
      <div className='croppedVideoContainer' style={{ visibility: (showCroppedVideo || selecteROIindex != 0) ? 'visible' : 'hidden' }}>
        {
          selecteROIindex != 0 && <CroppedVideo zoomAreaRatio={roiList[selecteROIindex]} playVideoRef={playVideoRef} visibleVideoDimensions={visibleVideoDimensions} videoAlign={videoAlign} progressBarTime={progressBarTime} enableROI={enableROI} vidheight={vidHeightVal} canvasRef={canvasRef} />
        }
      </div>
      {/* primary full video player */}
      <span style={{ visibility: selecteROIindex != 0 ? 'hidden' : 'visible' }}>
        <video
          className='video'
          autoload='metadata'
          muted={isMuted}
          ref={playVideoRef}
          preload='auto'
          onTimeUpdate={() => {
            setSeekerBar(progressBarRef.current.style.width);
          }}
          onClick={() => {
            (!enableROI || selecteROIindex != 0) && playPause(true);
          }}
          style={{
            display: 'block', marginBottom: '10px'
          }}
        >
          <source src={vidsrc} type='video/mp4' />
          Your browser does not support the video tag.
        </video>
      </span>
      <div className='roiControllButtonsContainer' style={{ visibility: enableROI ? 'visible' : 'hidden' }}>
        {!showCroppedVideo ?
          <>
            <button disabled={!zoomArea} style={{ cursor: !zoomArea ? 'not-allowed' : 'pointer', opacity: !zoomArea ? '0.5' : '1' }} className='roiButtons previewsubmitButton' onClick={handleSubmit} >
              <Tooltip
                title={"Please add ROI in Full video!."}
                disableHoverListener={zoomArea}
                placement="top"
                arrow><span> Preview ROI {selectedEditableROIindex != -1 ? roiList[selectedEditableROIindex].label : ''}</span>
              </Tooltip>
            </button>
          </> :
          <>
            <button className='roiButtons roiSubmitButton' onClick={() => handleOpen(selectedEditableROIindex == -1 ? 'Add' : 'Update')}>
              {selectedEditableROIindex == -1 ? "Save ROI" : `Save to ROI ${roiList[selectedEditableROIindex].roi_id}`}
            </button>
          </>
        }
      </div>

      <ConfirmationModal isThisCenterAligned={true} buttonAction={buttonAction} open={open} handleClose={handleClose} handleSubmitConfirmation={handleEventSubmitConfirmation} />
    </div>
  );
})


function CroppedVideo({ zoomAreaRatio, playVideoRef, visibleVideoDimensions, videoAlign, progressBarTime, enableROI, vidheight, canvasRef }) {
  const croppedCanvasRef = useRef(null);
useEffect(() => {
  const video = playVideoRef.current;
  const canvas = croppedCanvasRef.current;
  const ctx = canvas.getContext("2d");
  let animationFrameId;

  const drawCroppedVideo = () => {
    const zoomArea1 = calculateBoxFromPercentage(
      visibleVideoDimensions.videoWidth,
      visibleVideoDimensions.videoheight,
      zoomAreaRatio.x,
      zoomAreaRatio.y,
      zoomAreaRatio.width,
      zoomAreaRatio.height
    );

    if (video && zoomArea1) {
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      ctx.drawImage(
        video,
        zoomArea1.x,
        zoomArea1.y,
        zoomArea1.width,
        zoomArea1.height,
        0,
        0,
        canvas.width,
        canvas.height
      );

      animationFrameId = requestAnimationFrame(drawCroppedVideo);
    } else {
      console.error("Invalid video or zoom area");
    }
  };

  drawCroppedVideo();

  // Cleanup: stop animation loop when effect re-runs or component unmounts
  return () => cancelAnimationFrame(animationFrameId);
}, [progressBarTime, playVideoRef, videoAlign, enableROI]);

  useEffect(() => {
    const video = playVideoRef.current;
    const canvas = croppedCanvasRef.current;
    const ctx = canvas.getContext('2d');
    const zoomArea1 = calculateBoxFromPercentage(visibleVideoDimensions.videoWidth, visibleVideoDimensions.videoheight, zoomAreaRatio.x, zoomAreaRatio.y, zoomAreaRatio.width, zoomAreaRatio.height);
    const result = fitToFrame(zoomArea1.width, zoomArea1.height, visibleVideoDimensions.width, visibleVideoDimensions.height);

    const updateCanvasSize = () => {
      if (zoomAreaRatio) {
        canvas.width = result.newWidth;
        canvas.height = result.newHeight;
      }
    };
    const drawCroppedVideo = () => {

      const zoomArea1 = calculateBoxFromPercentage(visibleVideoDimensions.videoWidth, visibleVideoDimensions.videoheight, zoomAreaRatio.x, zoomAreaRatio.y, zoomAreaRatio.width, zoomAreaRatio.height);
      if (video && zoomArea1) {
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        ctx.drawImage(
          video,
          zoomArea1.x,
          zoomArea1.y,
          zoomArea1.width,
          zoomArea1.height,
          0,
          0,
          canvas.width,
          canvas.height
        );

        requestAnimationFrame(drawCroppedVideo);
      } else {
        console.error('Invalid video or zoom area');
      }
    };

    updateCanvasSize();
    drawCroppedVideo();
    video.addEventListener('play', () => {
      drawCroppedVideo();
    });
    return () => {
      video.removeEventListener('play', drawCroppedVideo);
    };

  }, [zoomAreaRatio, playVideoRef, progressBarTime]);

  const calculatePosition = () => {
    try {
      const video = playVideoRef.current;
      const zoomArea1 = calculateBoxFromPercentage(visibleVideoDimensions.videoWidth, visibleVideoDimensions.videoheight, zoomAreaRatio.x, zoomAreaRatio.y, zoomAreaRatio.width, zoomAreaRatio.height);
      const result = fitToFrame(zoomArea1.width, zoomArea1.height, visibleVideoDimensions.width, visibleVideoDimensions.height);
      let widthVal = 0, vHeight = vidheight;
      if (enableROI) {
        const canvas = canvasRef.current;
        widthVal = canvas.width;
        vHeight = canvas.height;
      } else {
        widthVal = (video.videoWidth / video.videoHeight) * vHeight;
      }
      let cntrPosition = calculateCenterPosition(widthVal, vHeight, result.newWidth, result.newHeight);
      cntrPosition.left = (videoAlign + cntrPosition.left)
      return cntrPosition;
    } catch {
      return {
        top: 0,
        left: 0
      }
    }
  }
  const cntrPosition = calculatePosition()

  return (
    <div>
      <canvas
        ref={croppedCanvasRef}
        style={{
          border: '1px solid black',
          display: 'block',
          marginLeft: `${cntrPosition.left}px`,
          marginTop: `${cntrPosition.top}px`
        }}
      ></canvas>
    </div>
  );
}
export default ROISelector;
